import React from 'react';
import PropTypes from 'prop-types';
import _map from 'lodash/map';
import {
  displayCurrency,
  formatAmountToOnlyNumbers,
} from '../../../../utils/amountUtils';
import { BodyText, Col } from '@paypalcorp/pp-react';
import templateData from '../../../../../utility/getTemplateData';
import { PresetAmounts } from '@paypalcorp/donate-react';

const isRTL = templateData.contextLocalityDir === 'rtl';

const PresetAmountButtonPreviewComponent = ({
  displayAmount,
  currencyCode,
}) => {
  return (
    <Col
      className={`${
        isRTL && 'rtl-preset-amount-button-preview-component'
      } preset-amount-button-preview-component`}
      lg={4}
    >
      <BodyText className="preset-amount-value-preview" strong>
        {displayAmount}
      </BodyText>
      <BodyText className="preset-amount-currency-preview" strong>
        {currencyCode}
      </BodyText>
    </Col>
  );
};

PresetAmountButtonPreviewComponent.propTypes = {
  displayAmount: PropTypes.string,
  currencyCode: PropTypes.string,
};

const PresetAmountPreviewComponent = ({
  amountOptions,
  currencyCode,
  otherAmountLabel,
  isMobile = false,
}) => {
  let presetAmountOptions = [];

  _map(amountOptions, (amount) => {
    const formattedAmount = displayCurrency(
      formatAmountToOnlyNumbers(amount),
      currencyCode,
      { noDecimals: true }
    );
    presetAmountOptions.push({
      label: formattedAmount,
      secondaryLabel: currencyCode,
      value: formattedAmount,
    });
  });

  const otherAmountOption = {
    label: otherAmountLabel,
    value: otherAmountLabel,
  };
  if (isRTL) {
    presetAmountOptions = [otherAmountOption, ...presetAmountOptions];
  } else {
    presetAmountOptions = [...presetAmountOptions, otherAmountOption];
  }

  return (
    <div
      id="preset-amount-preview-wrapper"
      className={`${
        isMobile
          ? 'preset-amount-preview-mobile-component'
          : 'preset-amount-preview-component'
      } bf-margin-top-12`}
    >
      <PresetAmounts
        presetOptions={presetAmountOptions}
        isMobilePreview={isMobile}
        isPreview={true}
      ></PresetAmounts>
    </div>
  );
};

PresetAmountPreviewComponent.propTypes = {
  amountOptions: PropTypes.array,
  currencyCode: PropTypes.string,
  isMobile: PropTypes.bool,
  otherAmountLabel: PropTypes.string,
};

export default PresetAmountPreviewComponent;
